import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query'

import projectReducer from '../../project/projectSlice';
import equipmentEditReducer from './equipmentEditSlice';
import { projectApi } from '../../project/projectApi';
import { settingsApi } from '../api/settingsApi';
import { authApi } from '../api/authApi';
import { adminApi } from '../../admin/adminApi';
import areaHoverReducer from './areaHoverSlice';

export const store = configureStore({
    reducer: {
        project: projectReducer,
        equipmentEdit: equipmentEditReducer,
        areaHover: areaHoverReducer,
        [projectApi.reducerPath]: projectApi.reducer,
        [settingsApi.reducerPath]: settingsApi.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [adminApi.reducerPath]: adminApi.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(projectApi.middleware)
    .concat(settingsApi.middleware)
    .concat(authApi.middleware)
    .concat(adminApi.middleware)
});

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;